import callApi from './callApi';

export const getWeblinks = async (entityType, entityId) => {
  const url = `associations/weblinks/${entityType}/${entityId}`;
  return await callApi(url, {}, 'GET');
}

export const createWeblink = async (data) => {
  const url = `associations/weblinks`;
  return await callApi(url, {}, 'POST', data);
}

export const removeWeblink = async (id) => {
  const url = `associations/weblinks/${id}`;
  return await callApi(url, {}, 'DELETE');
}

export const updateWeblink = async (id, data) => {
  const url = `associations/weblinks/${id}`;
  return await callApi(url, {}, 'PUT', data);
}

export const sendQuery = async (data) => {
  const url = `notifications/send-query-email`;
  const body = {
    data
  }
  return await callApi(url, {}, 'POST', body);
}